import { translate, useLocale } from "../../localization";
import React, { useState } from 'react';
import './ContactForm.scss';
import { AppButton } from "../ui";

const ContactForm = () => {
  useLocale();
  const [status, setStatus] = useState('');

  const submitForm = (ev) => {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        setStatus(translate("SUCCESS"));
      } else {
        setStatus(translate("ERROR"));
      }
    };
    xhr.send(data);
  }

  return (
    <form
      onSubmit={submitForm}
      action="https://formspree.io/f/mrgnqryj" // Replace {yourFormId} with your Formspree form ID
      method="POST"
      className="contact-form"
    >
      <label htmlFor="name">{translate("Your name")}</label>
      <input type="text" name="name" id="name" required />

      <label htmlFor="email">{translate("Email")}</label>
      <input type="email" name="email" id="email" required />

      <label htmlFor="message">{translate("What do you want to discuss?")}</label>
      <textarea name="message" id="message" required></textarea>

      {status === "SUCCESS" ? (
        <p className="contact-form__status--success">{translate("Thanks! Talk to you soon.")}</p>
      ) : (
        <AppButton kind="primary">{translate("Submit")}</AppButton>
      )}
      {status === "ERROR" && (
        <p className="contact-form__status--error">{translate("Ooops! There was an error. Please try again.")}</p>
      )}
    </form>
  );
};

export default ContactForm;
